import FormArea from "./FormArea/FormArea";

export default function StepThird() {
  return <FormArea />;
}